import { render, staticRenderFns } from "./MainImage.vue?vue&type=template&id=198c355a&scoped=true&"
import script from "./MainImage.vue?vue&type=script&lang=ts&"
export * from "./MainImage.vue?vue&type=script&lang=ts&"
import style0 from "./MainImage.vue?vue&type=style&index=0&id=198c355a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198c355a",
  null
  
)

export default component.exports